import type { MapBody } from '@shared/mapDefinitions.js';

const def: MapBody<'interactive'> = {
  attribution: [],
};

export default def;
